import { useQuery } from 'react-query';

import client from '@/apis/aniftyBackend/client';

type GetReleaseReminderResponseBody = {
  exist: boolean;
};

export const getReleaseReminder = async ({
  creationID,
}: {
  creationID: number;
}): Promise<boolean> => {
  return client
    .get<GetReleaseReminderResponseBody>('/api/release_reminders', {
      params: { creationID },
    })
    .then((response) => response.data.exist);
};

export const useReleaseReminder = ({
  creationID,
  accessTokenExists,
}: {
  creationID: number;
  accessTokenExists: boolean;
}) => {
  return useQuery({
    queryKey: ['releaseReminders', creationID],
    queryFn: () => getReleaseReminder({ creationID }),
    enabled: accessTokenExists,
  });
};
